import React from 'react';
import Select from 'react-select';

import { CreateUpdateSalesInvoiceDtoStatusEnum } from '../../../common/spdCore/autogenerated/spdApiClient';
import {
  SalesInvoiceStatusEnum,
  SalesInvoiceStatusEnumText,
} from '../../../common/spdCore/validation/enums';

interface SalesInvoiceStatusSelectorProps {
  value?: string;
  onChange: (value: string | undefined) => void;
  isDisabled?: boolean;
  withoutKseF?: boolean;
}

export const SalesInvoiceStatusSelector: React.FC<
  SalesInvoiceStatusSelectorProps
> = ({ value, onChange, isDisabled, withoutKseF }) => {
  const options = Object.values(SalesInvoiceStatusEnum)
    .filter(s => !withoutKseF || s !== SalesInvoiceStatusEnum.InKSeF)
    .map(s => ({
      value: s as unknown as CreateUpdateSalesInvoiceDtoStatusEnum,
      label: SalesInvoiceStatusEnumText[s],
    }));

  const allOptions = Object.values(SalesInvoiceStatusEnum).map(s => ({
    value: s as unknown as CreateUpdateSalesInvoiceDtoStatusEnum,
    label: SalesInvoiceStatusEnumText[s],
  }));

  const selected = value
    ? (allOptions.find(({ value: v }) => (v as string) === value) ?? null)
    : null;

  return (
    <Select
      value={selected}
      options={options}
      onChange={option => onChange(option?.value)}
      isDisabled={isDisabled}
    />
  );
};
